/**
 * Lifty Electric - Custom Specification Filter Engine
 * Filters products by Single/Dual Motor, Tyre Size, Brake Type, IP Rating, and Weight Capacity
 */
(function() {
  function initLiftyFilters() {
    var filterLinks = document.querySelectorAll('[data-lifty-filter-group] li a');
    if (!filterLinks.length) return;

    var grid = document.querySelector('.t4s-products');
    if (!grid) return;

    var products = Array.prototype.slice.call(grid.querySelectorAll('.t4s-product'));
    if (!products.length) return;

    // Helper: calculate live count for each filter option
    function updateCounts() {
      var groups = ['motor', 'tyre', 'brake', 'ip', 'capacity'];
      groups.forEach(function(group) {
        var items = document.querySelectorAll('[data-lifty-filter-group="' + group + '"] li');
        items.forEach(function(item) {
          var val = item.getAttribute('data-filter-val');
          var selector = '.filter-' + group + '-' + val;
          var count = grid.querySelectorAll('.t4s-product' + selector).length;
          var countSpan = item.querySelector('.t4s-value-count');
          if (countSpan) {
            countSpan.textContent = '(' + count + ')';
          }
        });
      });
    }

    updateCounts();

    // Helper: get all selected filter values per group
    function getSelectedFilters() {
      var selected = {};
      var groups = document.querySelectorAll('[data-lifty-filter-group]');
      groups.forEach(function(groupEl) {
        var groupName = groupEl.getAttribute('data-lifty-filter-group');
        var activeItems = groupEl.querySelectorAll('li.is--selected');
        if (activeItems.length > 0) {
          selected[groupName] = [];
          activeItems.forEach(function(item) {
            var val = item.getAttribute('data-filter-val');
            var text = item.querySelector('a').innerText.split('(')[0].trim();
            selected[groupName].push({ val: val, text: text });
          });
        }
      });
      return selected;
    }

    // Apply filter to grid products
    function applyFilters() {
      var selected = getSelectedFilters();
      var activeGroupNames = Object.keys(selected);
      var visibleCount = 0;

      products.forEach(function(pr) {
        var matches = true;

        for (var i = 0; i < activeGroupNames.length; i++) {
          var groupName = activeGroupNames[i];
          var vals = selected[groupName];
          var groupMatch = false;

          for (var j = 0; j < vals.length; j++) {
            var className = 'filter-' + groupName + '-' + vals[j].val;
            if (pr.classList.contains(className)) {
              groupMatch = true;
              break;
            }
          }

          if (!groupMatch) {
            matches = false;
            break;
          }
        }

        if (matches) {
          pr.classList.remove('lifty-filter-hidden');
          visibleCount++;
        } else {
          pr.classList.add('lifty-filter-hidden');
        }
      });

      // Update Isotope if initialized
      if (window.jQuery && window.jQuery('.isotopet4s').length) {
        var $iso = window.jQuery('.isotopet4s');
        if ($iso.data('isotope')) {
          $iso.isotope({
            filter: function() {
              return !this.classList.contains('lifty-filter-hidden');
            }
          });
        }
      }

      // Update counter
      var barCurrent = document.querySelector('[data-current-bar]');
      if (barCurrent) {
        barCurrent.textContent = visibleCount;
      }

      // Update Active Filters Bar above grid
      renderActivePills(selected);
    }

    // Render active filter chips above grid
    function renderActivePills(selected) {
      var activeContainer = document.querySelector('.t4s-active-filters');
      if (!activeContainer) {
        var mainArea = document.querySelector('.t4s-main-area');
        if (mainArea) {
          activeContainer = document.createElement('div');
          activeContainer.className = 't4s-active-filters lifty-active-filters-injected';
          mainArea.parentNode.insertBefore(activeContainer, mainArea);
        }
      }

      if (!activeContainer) return;

      var existingCustomPills = activeContainer.querySelectorAll('.lifty-active-spec-pill, .lifty-clear-spec-filters');
      existingCustomPills.forEach(function(el) { el.remove(); });

      var totalActive = 0;
      var activeGroupNames = Object.keys(selected);

      activeGroupNames.forEach(function(groupName) {
        selected[groupName].forEach(function(item) {
          totalActive++;
          var pill = document.createElement('a');
          pill.className = 'lifty-active-spec-pill';
          pill.setAttribute('role', 'button');
          pill.innerHTML = item.text + ' <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 1l8 8m0-8L1 9"/></svg>';
          pill.addEventListener('click', function(e) {
            e.preventDefault();
            var targetLi = document.querySelector('[data-lifty-filter-group="' + groupName + '"] li[data-filter-val="' + item.val + '"]');
            if (targetLi) {
              targetLi.classList.remove('is--selected');
              var link = targetLi.querySelector('a');
              if (link) link.setAttribute('aria-pressed', 'false');
            }
            applyFilters();
          });
          activeContainer.appendChild(pill);
        });
      });

      if (totalActive > 0) {
        var clearBtn = document.createElement('a');
        clearBtn.className = 't4s-active-filters__clear lifty-clear-spec-filters';
        clearBtn.setAttribute('role', 'button');
        clearBtn.textContent = 'Clear all filters';
        clearBtn.addEventListener('click', function(e) {
          e.preventDefault();
          document.querySelectorAll('[data-lifty-filter-group] li.is--selected').forEach(function(li) {
            li.classList.remove('is--selected');
            var link = li.querySelector('a');
            if (link) link.setAttribute('aria-pressed', 'false');
          });
          applyFilters();
        });
        activeContainer.appendChild(clearBtn);
      }
    }

    // Bind click events on filter links
    filterLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var li = link.closest('li');
        if (!li) return;

        var isSelected = li.classList.contains('is--selected');
        if (isSelected) {
          li.classList.remove('is--selected');
          link.setAttribute('aria-pressed', 'false');
        } else {
          li.classList.add('is--selected');
          link.setAttribute('aria-pressed', 'true');
        }

        applyFilters();
      });
    });

    // Check URL parameters on page load
    try {
      var params = new URLSearchParams(window.location.search);
      var hasUrlFilter = false;
      ['motor', 'tyre', 'brake', 'ip', 'capacity'].forEach(function(group) {
        var paramVal = params.get(group);
        if (paramVal) {
          var targetLi = document.querySelector('[data-lifty-filter-group="' + group + '"] li[data-filter-val="' + paramVal + '"]');
          if (targetLi) {
            targetLi.classList.add('is--selected');
            hasUrlFilter = true;
          }
        }
      });
      if (hasUrlFilter) {
        applyFilters();
      }
    } catch(err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLiftyFilters);
  } else {
    initLiftyFilters();
  }

  document.addEventListener('shopify:section:load', initLiftyFilters);
})();
